const embed =
{
    tooltip : 'Ajouter un média externe'
};

export default embed ;